module.exports = __webpack_public_path__ + "static/standalone/img/amount-insolvency.37115190.svg";